namespace SP {
    export enum Period {
        Today = 1,
        Yesterday = 2,
        ThisWeek = 3,
        LastWeek = 4,
        ThisMonth = 5,
        LastMonth = 6,
        ThisYear = 7,
        LastYear = 8,
        Last7Days = 9,
        Last30Days = 10,
        Last365Days = 11
    }
}